import { resetItemsDisplayOrder } from '../util';

class Form {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.collapse_product_form = data.collapse_product_form || 'no';
    this.form_type = data.form_type || 'simple';
    this.items = data.items || [];
    this.logic_groups = data.logic_groups || [];
    this.name = data.name || '';
    this.name_l10n = data.name_l10n || [];
    this.display_order = data.display_order || 0;
    this.products = data.products || [];
    this.location_variables = data.location_variables || [];
    this.role_variables = data.role_variables || [];
    this.locations = data.locations || [];
    this.merchandising_activities = (data.merchandising_activities || [])
      .map(activity => ({
        ...activity,
        id: Number(activity && activity.id),
      }))
      .filter(activity => Number.isFinite(activity.id) && activity.id > 0);
  }

  addItem(item) {
    this.items.push(item);
    resetItemsDisplayOrder(this.items);
  }

  insertItem(item, index) {
    this.items.splice(index, 0, item);
    resetItemsDisplayOrder(this.items);
  }

  addLogicGroup(logicGroup) {
    this.logic_groups.push(logicGroup);
  }

  removeLogicGroup(logicGroup) {
    let idx = this.logic_groups.indexOf(logicGroup);
    if (idx !== -1) {
      this.logic_groups.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  get hasProducts() {
    return this.products.length > 0;
  }

  get hasLocationVariables() {
    return this.location_variables.length > 0;
  }

  get hasRoleVariables() {
    return this.role_variables.length > 0;
  }

  get hasLocations() {
    return this.locations.length > 0;
  }

  get type() {
    const types = ['simple', 'product', 'survey', 'merchandising', 'sampling'];
    const defaultType = 'simple';
    if (types.indexOf(this.form_type) !== -1) {
      return this.form_type;
    } else {
      return defaultType;
    }
  }

  removeAllLocationVariables() {
    this.location_variables.length = 0;
  }

  removeAllRoleVariables() {
    this.role_variables.length = 0;
  }

  removeAllLocations() {
    this.locations.length = 0;
  }

  get isSimpleForm() {
    return this.type === 'simple';
  }

  get isProductForm() {
    return this.type === 'product';
  }

  get isSurveyForm() {
    return this.type === 'survey';
  }

  /**
   * Merchandising forms behave like survey forms (repeatable, free instance
   * count) but automatically attach a per-instance activity-type and product
   * picker. Used by the Phase 3 "Account Call" recap pattern.
   */
  get isMerchandisingForm() {
    return this.type === 'merchandising';
  }

  get isSamplingForm() {
    return this.type === 'sampling';
  }

  get isProductScopeForm() {
    return this.isMerchandisingForm || this.isSamplingForm;
  }

  get isRepeatableForm() {
    return !this.isSimpleForm;
  }

  get isFieldInstance() {
    return false;
  }

  get isForm() {
    return true;
  }

  getProductWithId(id) {
    if (this.hasProducts) {
      // Server-loaded form_responses carry product ids as strings; the
      // merchandising scope service casts to int. Compare numerically so
      // either side works regardless of source.
      const target = Number(id);
      return this.products.find(product => Number(product.id) === target);
    }
    return null;
  }
}

export default Form;
